<div>
  @if (step === 'request') {
    <p class="mb-4 text-sm text-gray-500">Esqueceu a palavra-chave? Indique o número de telefone da conta e enviaremos
      um PIN por SMS.</p>

    <form method="post" [formGroup]="form" (ngSubmit)="onRequestPin()">
      <div class="mt-8 text-xs">
        <app-phone-number-field>
          <app-text-input [formGroup]="form" type="number" id="phoneNumber" label="Número de telefone"
                          [hideCounter]="true"
                          [maxLength]="9" [formError]="formErrors.get('phoneNumber')"></app-text-input>
        </app-phone-number-field>
      </div>

      <div class="mt-6">
        <app-ae-button variant="primary" label="Enviar PIN" (buttonClick)="onRequestPin()"
                       size="sm" styleClass="w-full text-xs"></app-ae-button>
      </div>
    </form>

    <p class="mt-6 text-sm text-center text-gray-500">
      <button type="button" class="text-blue-500 focus:outline-none focus:underline hover:underline"
              (click)="showStep('confirm')">
        Já tenho o PIN
      </button>
    </p>
  } @else {
    <p class="mb-4 text-sm text-gray-500">Introduza o PIN recebido por SMS e defina a nova palavra-chave.</p>

    <form method="post" class="space-y-8 text-xs" [formGroup]="form" (ngSubmit)="onConfirmPin()">
      <div class="mt-8 text-xs">
        <app-phone-number-field>
          <app-text-input [formGroup]="form" type="number" id="phoneNumber" label="Número de telefone"
                          [hideCounter]="true"
                          [maxLength]="9" [value]="form.value?.phoneNumber"
                          [formError]="formErrors.get('phoneNumber')"></app-text-input>
        </app-phone-number-field>
      </div>

      <div>
        <app-text-input [formGroup]="form" type="text" id="pin" [maxLength]="5" [hideCounter]="true"
                        [value]="form.value?.pin" label="PIN"
                        [formError]="formErrors.get('pin')"></app-text-input>
      </div>

      <div>
        <app-text-input [formGroup]="form" id="password" [maxLength]="100" [value]="form.value?.password"
                        label="Nova palavra-chave" type="password" [hideCounter]="true"
                        [formError]="formErrors.get('password')"></app-text-input>
      </div>

      <div>
        <app-text-input [formGroup]="form" id="passwordRe" [maxLength]="100" [value]="form.value?.passwordRe"
                        label="Repita a palavra-chave" type="password" [hideCounter]="true"
                        [formError]="formErrors.get('passwordRe')"></app-text-input>
      </div>

      <div class="mt-6">
        <app-ae-button variant="primary" label="Alterar palavra-chave"
                       (buttonClick)="onConfirmPin()" size="sm" styleClass="w-full text-xs"></app-ae-button>
      </div>
    </form>

    <p class="mt-6 text-sm text-center text-gray-500">
      <button type="button" class="text-blue-500 focus:outline-none focus:underline hover:underline"
              (click)="showStep('request')">
        Pedir outro PIN
      </button>
    </p>
  }

  <p class="mt-6 text-sm text-center text-gray-500">Já possui conta?
    <a routerLink="/acesso" class="text-blue-500 focus:outline-none focus:underline hover:underline">
      Clique aqui para aceder!</a></p>
</div>
